import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    alias: '首页',
    component: Home,
    meta: {
      // isLogin: true,
      title: '首页', keepAlive: true
    }
  },
  {
    path: '/login',
    name: 'login',
    alias: '登录',
    component: () => import('@/views/login/login.vue'),
    meta: {
      title: '登录', keepAlive: true
    }
  },
  {
    path: '/company',
    name: 'company',
    alias: '展商名录',
    component: () => import('@/views/company/company.vue'),
    meta: {
      title: '展商名录', keepAlive: true
    }
  },
  {
    path: '/companyDetail',
    name: 'companyDetail',
    alias: '展商详情',
    component: () => import('@/views/company/companyDetail.vue'),
    meta: {
      title: '展商详情', keepAlive: false
    }
  },
  {
    path: '/product',
    name: 'product',
    alias: '产品名录',
    component: () => import('@/views/product/product.vue'),
    meta: {
      title: '产品名录', keepAlive: true
    }
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    alias: '产品详情',
    component: () => import('@/views/product/productDetail.vue'),
    meta: {
      title: '产品详情', keepAlive: false
    }
  },
  {
    path: '/business',
    name: 'business',
    alias: '发布商机',
    component: () => import('@/views/business/business.vue'),
    meta: {
      title: '发布商机', keepAlive: true
    }
  },
  {
    path: '/businessDetail',
    name: 'businessDetail',
    alias: '商机详情',
    component: () => import('@/views/business/businessDetail.vue'),
    meta: {
      title: '商机详情', keepAlive: false
    }
  },
  {
    path: '/webContent',
    name: 'webContent',
    alias: '二级页面',
    component: () => import('@/views/expo/webContent.vue'),
    meta: {
      title: '二级页面', keepAlive: true
    }
  },
  {
    path: '/webContentV',
    name: 'webContentV',
    alias: '二级页面',
    component: () => import('@/views/expo/webContentV.vue'),
    meta: {
      title: '二级页面', keepAlive: true
    }
  },
  {
    path: '/partner',
    name: 'partner',
    alias: '合作伙伴',
    component: () => import('@/views/expo/partner.vue'),
    meta: {
      title: '合作伙伴', keepAlive: true
    }
  },
  {
    path: '/contacts',
    name: 'contacts',
    alias: '联系我们',
    component: () => import('@/views/expo/contacts.vue'),
    meta: {
      title: '联系我们', keepAlive: true
    }
  },
  {
    path: '/news',
    name: 'news',
    alias: '新闻中心',
    component: () => import('@/views/expo/news.vue'),
    meta: {
      title: '新闻中心', keepAlive: true
    }
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    alias: '新闻详情',
    component: () => import('@/views/expo/newsDetails.vue'),
    meta: {
      title: '新闻详情', keepAlive: true
    }
  },
  {
    path: '/downloads',
    name: 'downloads',
    alias: '下载中心',
    component: () => import('@/views/expo/downloads.vue'),
    meta: {
      title: '下载中心', keepAlive: true
    }
  },
  {
    path: '/join',
    name: 'join',
    alias: '我要参展',
    component: () => import('@/views/company/join.vue'),
    meta: {
      title: '我要参展', keepAlive: true
    }
  },
  {
    path: '/floorplan',
    name: 'floorplan',
    alias: '展位图',
    component: () => import('@/views/company/floorplan.vue'),
    meta: {
      title: '展位图', keepAlive: true
    }
  },
  {
    path: '/liveEvents',
    name: 'liveEvents',
    alias: '现场活动',
    component: () => import('@/views/active/liveEvents.vue'),
    meta: {
      title: '现场活动', keepAlive: true
    }
  },
  {
    path: '/liveEventsDetail',
    name: 'liveEventsDetail',
    alias: '活动详情',
    component: () => import('@/views/active/liveEventsDetail.vue'),
    meta: {
      title: '活动详情', keepAlive: false
    }
  },
  {
    path: '/personal',
    name: 'personal',
    alias: '个人资料',
    component: () => import('@/views/personal/personal.vue'),
    meta: {
      title: '个人资料', keepAlive: true, isLogin: true,
    }
  },
  {
    path: '/mycollect',
    name: 'mycollect',
    alias: '我的收藏',
    component: () => import('@/views/mine/mycollect.vue'),
    meta: {
      title: '我的收藏', keepAlive: true, isLogin: true,
    }
  },
  {
    path: '/mybusiness',
    name: 'mybusiness',
    alias: '我的商机',
    component: () => import('@/views/mine/mybusiness.vue'),
    meta: {
      title: '我的商机', keepAlive: true, isLogin: true,
    }
  },
  {
    path: '/plan',
    name: 'plan',
    alias: '展位图',
    component: () => import('@/views/company/plan.vue'),
    meta: {
      title: '展位图', keepAlive: true
    }
  },
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
